function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVitest = function SvgVitest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width,
    height: props.height,
    fill: "none",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.992 76.98a3.859 3.859 0 0 0 2.739-1.133l18.07-18.07a3.87 3.87 0 0 0-.007-5.469 3.873 3.873 0 0 0-5.469-.008L39.992 67.632 6.588 34.23a3.872 3.872 0 0 0-5.476 5.476l36.142 36.14a3.859 3.859 0 0 0 2.738 1.135Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.036 26.128 40.91 53.78a1.646 1.646 0 0 1-2.712-.004 1.63 1.63 0 0 1-.282-1l.766-15.268-12.357-2.62a1.642 1.642 0 0 1-1.183-.994 1.626 1.626 0 0 1 .174-1.532L44.444 4.709a1.645 1.645 0 0 1 2.711.005c.201.294.3.645.282 1l-.765 15.268 12.357 2.62a1.643 1.643 0 0 1 1.182.994 1.626 1.626 0 0 1-.174 1.532Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.007 76.98a3.86 3.86 0 0 1-2.739-1.133l-18.07-18.07a3.872 3.872 0 0 1 5.475-5.477l15.334 15.332L73.41 34.23a3.872 3.872 0 0 1 5.476 5.476l-36.142 36.14a3.858 3.858 0 0 1-2.738 1.135Z",
    fill: props.color,
    stroke: props.color
  })));
};
export default SvgVitest;